import { ClassifierMappingOverviewDto } from '../types';
import { Page, PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { expand } from 'uri-template-lite';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ClassifierMappingUrl } from './ClassifierMappingUrl';

export interface ClassifierMappingFilter {
  search?: string;
  code?: string;
  name?: string;
  classifierFromCode?: string;
  classifierToCode?: string;
  description?: string;
}

const getClassifierMapperList = (
  params?: ClassifierMappingFilter &
    PageRequestParams<keyof ClassifierMappingFilter>
) =>
  apiClient
    .get<Page<ClassifierMappingOverviewDto>>(
      expand(ClassifierMappingUrl.CLASSIFIER_MAPPING, params)
    )
    .then((response) => response.data);

export const useListClassifierMappingQuery = createApiQueryHook(
  ['classifierMapperList'],
  getClassifierMapperList
);
